import { render, staticRenderFns } from "./Blacklists.vue?vue&type=template&id=a822284c&"
import script from "./Blacklists.vue?vue&type=script&lang=ts&"
export * from "./Blacklists.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports